import React from 'react';
import {Link, useNavigate, useLocation} from 'react-router-dom';
import {getCurrentUserRole} from '../utils/authHelper';
import {logout, isLoggedIn} from '../auth';
import '../styles/NavigationBar.css';

export default function NavigationBar() {
    const navigate = useNavigate();
    const location = useLocation();
    const role = getCurrentUserRole();

    const handleLogout = () => {
        logout();
        navigate('/');
    };

    const isActive = (path) => location.pathname.startsWith(path);

    return (
        <nav className="navbar">
            <div className="navbar-left">
                <img src="/logo.png" alt="Logo" className="logo"/>

                {role === 'admin' && (
                    <>
                        <Link to="/customer_contacts" className={isActive('/contact_dashboard') ? 'active' : ''}>Kontakte</Link>
                        <Link to="/customers" className={isActive('/customers') ? 'active' : ''}>Kunden</Link>
                        <Link to="/projects" className={isActive('/projects') ? 'active' : ''}>Projekte</Link>
                        <Link to="/project_acquisition"
                              className={isActive('/project_acquisition') ? 'active' : ''}>Projektaquise</Link>
                    </>
                )}

                <Link to="/timeentries" className={isActive('/timeentries') ? 'active' : ''}>Zeiterfassung</Link>
                <Link to="/employee" className={isActive('/employee') ? 'active' : ''}>Mitarbeiterbreich</Link>
                <Link to="/settings" className={isActive('/settings') ? 'active' : ''}>Einstellungen</Link>
            </div>
            <div className="navbar-right">
                {isLoggedIn() && (
                    <button onClick={handleLogout} className="button button-danger">
                        Logout
                    </button>
                )}
            </div>
        </nav>
    );
}
